export default "__VITE_ASSET__B0MHoWVY__"